export const categoryList = [
    {
        id: 1,
        name: "BEDSHEET SET",
        imageUrl: "Bedsheets-category",
        link: "/products",
        icon: "bedsheet"
    }, {
        id: 2,
        name: "BEDSPREADS",
        imageUrl: "Bedspread-category",
        link: "/products",
        icon: "cushion-cover"
    }, {
        id: 3,
        name: "DUVET COVERS",
        imageUrl: "Duvet-Cover-category",
        link: "/products",
        icon: "duvet"
    }, {
        id: 4,
        name: "COMFORTERS",
        imageUrl: "Comforters-category",
        link: "/products",
        icon: "comfortor"
    }, {
        id: 5,
        name: "Bedding Set",
        imageUrl: "Bed-in-a-Bag-category",
        link: "/products",
        icon: "bed-in-bag"
    }, {
        id: 6,
        name: "PILLOW COVER",
        imageUrl: "Pillow-Cover-category",
        link: "/products",
        icon: "pillow-cover"
    }
]